/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component} from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';

@Component({
  standalone: true,
  selector: 'adn-agent-order-confirm-modal',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">Put the line item in this order?</h4>
    </div>
    <div class="modal-body">
      @if (known) {
        <p>An AI agent booked this order.</p>
      } @else {
        <p>The order could not be checked. An AI agent may have booked it.</p>
      }
      <p>The agent can change and submit any proposed line item in an order that it booked, including line items that people add.</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-link btn-xs" (click)="cancel()">Cancel</button>
      <button type="button" class="btn btn-default" (click)="confirm()">Use This Order</button>
    </div>
  `
})
export class AgentOrderConfirmModalComponent {
  /** Set via BsModalService initialState */
  known = true;
  /** Set via BsModalService initialState */
  onConfirm: () => void;
  /** Set via BsModalService initialState */
  onCancel: () => void;

  constructor(
    public readonly bsModalRef: BsModalRef,
    private readonly bsModalService: BsModalService
  ) {
  }

  confirm(): void {
    this.onConfirm?.();
    this.hide();
  }

  cancel(): void {
    this.onCancel?.();
    this.hide();
  }

  /** bsModalRef.hide() does nothing until the modal has finished opening; BsModalService.hide(id) always closes it. */
  private hide(): void {
    const id = this.bsModalRef.id;
    if (id !== null && id !== undefined) {
      this.bsModalService.hide(id);
      return;
    }
    this.bsModalRef.hide();
  }
}
